/* ============================================================
   OXIFY — Luxury Hyperbaric product page
   Shared, dependency-free interactivity for all oxify-product-*
   sections. Each behaviour self-initialises and is safe to run
   in the Shopify theme editor (re-inits on section load).
   ============================================================ */
(function () {
  "use strict";

  // Mark the doc so CSS can hide-then-reveal. If JS never runs, content
  // simply stays visible (graceful degradation).
  document.documentElement.classList.add("oxy-js");

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Scroll reveal ----------
     Rect-based (NOT IntersectionObserver): IO is unreliable in sandboxed
     frames such as the Shopify theme-editor preview, which would leave
     [data-reveal] elements — including every image frame — permanently
     hidden. Rect checks + a hard safety net guarantee content always shows. */
  var revealStarted = false;
  function revealAll() {
    var els = document.querySelectorAll(".oxify-product-page [data-reveal]:not([data-inview])");
    for (var i = 0; i < els.length; i++) els[i].setAttribute("data-inview", "1");
  }
  function revealCheck() {
    var vh = window.innerHeight || document.documentElement.clientHeight || 800;
    var els = document.querySelectorAll(".oxify-product-page [data-reveal]:not([data-inview])");
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > -80) els[i].setAttribute("data-inview", "1");
    }
  }
  function initReveal() {
    if (reduceMotion) { revealAll(); return; }
    revealCheck();
    if (revealStarted) { return; }
    revealStarted = true;
    window.addEventListener("scroll", revealCheck, { passive: true });
    window.addEventListener("resize", revealCheck);
    var ticks = 0;
    var iv = setInterval(function () { revealCheck(); if (++ticks > 48) clearInterval(iv); }, 250); // ~12s
    // Ultimate safety: never leave anything hidden, even if checks somehow miss it.
    setTimeout(revealAll, 4000);
  }

  /* ---------- Count-up numbers ---------- */
  function runCount(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var decimals = parseInt(el.getAttribute("data-decimals") || "0", 10);
    if (isNaN(target)) return;
    if (reduceMotion) { el.textContent = target.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }); return; }
    var dur = 1700, t0 = null;
    function tick(now) {
      if (!t0) t0 = now;
      var p = Math.min(1, (now - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = val.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = target.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    }
    requestAnimationFrame(tick);
  }
  function initCounters(root) {
    var els = (root || document).querySelectorAll(".oxify-product-page [data-count]:not([data-oxy-count-bound])");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(function (el) { el.setAttribute("data-oxy-count-bound", "1"); runCount(el); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { el.setAttribute("data-oxy-count-bound", "1"); io.observe(el); });
  }

  /* ---------- Sliders (marketing gallery + hero gallery) ---------- */
  function initSliders(root) {
    var sliders = (root || document).querySelectorAll("[data-oxy-slider]:not([data-oxy-slider-bound])");
    sliders.forEach(function (slider) {
      slider.setAttribute("data-oxy-slider-bound", "1");
      var slides = Array.prototype.slice.call(slider.querySelectorAll(".oxy-slide"));
      var dots = Array.prototype.slice.call(slider.parentNode.querySelectorAll(".oxy-dot"));
      var counter = slider.parentNode.querySelector(".oxy-count .cur");
      var prev = slider.parentNode.querySelector(".oxy-arrow.prev");
      var next = slider.parentNode.querySelector(".oxy-arrow.next");
      if (slides.length < 1) return;
      var active = 0, timer = null;
      var autoplay = slider.getAttribute("data-autoplay") === "true";

      function show(i) {
        active = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle("is-active", idx === active); });
        dots.forEach(function (d, idx) { d.classList.toggle("is-active", idx === active); });
        if (counter) counter.textContent = String(active + 1).padStart(2, "0");
      }
      function start() { if (autoplay && !reduceMotion && slides.length > 1) { stop(); timer = setInterval(function () { show(active + 1); }, 4500); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener("click", function () { show(active - 1); start(); });
      if (next) next.addEventListener("click", function () { show(active + 1); start(); });
      dots.forEach(function (d, idx) { d.addEventListener("click", function () { show(idx); start(); }); });
      slider.parentNode.addEventListener("mouseenter", stop);
      slider.parentNode.addEventListener("mouseleave", start);
      show(0); start();
    });
  }

  /* ---------- Thumbnail galleries (product media) ---------- */
  function initThumbGalleries(root) {
    var galleries = (root || document).querySelectorAll("[data-oxy-thumbgallery]:not([data-oxy-tg-bound])");
    galleries.forEach(function (g) {
      g.setAttribute("data-oxy-tg-bound", "1");
      var slides = Array.prototype.slice.call(g.querySelectorAll(".oxy-gallery-main .oxy-slide"));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll(".oxy-thumb"));
      var track = g.querySelector("[data-oxy-thumbs-track]");
      var tPrev = g.querySelector("[data-oxy-thumbs-prev]");
      var tNext = g.querySelector("[data-oxy-thumbs-next]");
      function show(i) {
        slides.forEach(function (s, idx) { s.classList.toggle("is-active", idx === i); });
        thumbs.forEach(function (t, idx) {
          var on = idx === i;
          t.classList.toggle("is-active", on);
          if (on && track && t.scrollIntoView) { try { t.scrollIntoView({ inline: "nearest", block: "nearest" }); } catch (e) {} }
        });
      }
      thumbs.forEach(function (t, idx) {
        t.addEventListener("click", function () { show(idx); });
      });
      // filmstrip arrows — page the row; auto-hide at each end
      if (track) {
        function pageThumbs(dir) { track.scrollBy({ left: dir * Math.max(120, track.clientWidth * 0.8), behavior: "smooth" }); }
        function updateArrows() {
          var atStart = track.scrollLeft <= 2;
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
          var noScroll = track.scrollWidth <= track.clientWidth + 2;
          if (tPrev) tPrev.setAttribute("data-disabled", (noScroll || atStart) ? "1" : "0");
          if (tNext) tNext.setAttribute("data-disabled", (noScroll || atEnd) ? "1" : "0");
        }
        if (tPrev) tPrev.addEventListener("click", function () { pageThumbs(-1); });
        if (tNext) tNext.addEventListener("click", function () { pageThumbs(1); });
        track.addEventListener("scroll", updateArrows, { passive: true });
        window.addEventListener("resize", updateArrows);
        updateArrows();
      }
      // Allow the variant picker to switch the gallery to a variant's image.
      g.addEventListener("oxy:select-media", function (e) {
        var mediaId = e.detail && e.detail.mediaId;
        if (!mediaId) return;
        var idx = slides.findIndex(function (s) { return s.getAttribute("data-media-id") === String(mediaId); });
        if (idx > -1) show(idx);
      });
      if (slides.length) show(0);
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    var items = (root || document).querySelectorAll(".oxy-faq__item:not([data-oxy-faq-bound])");
    items.forEach(function (item) {
      item.setAttribute("data-oxy-faq-bound", "1");
      var btn = item.querySelector(".oxy-faq__q");
      var panel = item.querySelector(".oxy-faq__a");
      if (!btn || !panel) return;
      btn.addEventListener("click", function () {
        var open = item.getAttribute("aria-expanded") === "true";
        item.setAttribute("aria-expanded", open ? "false" : "true");
        btn.setAttribute("aria-expanded", open ? "false" : "true");
        panel.style.maxHeight = open ? "0px" : panel.scrollHeight + "px";
      });
    });
  }

  /* ---------- What's Included: accordion + crossfading image ----------
     Non-collapsible (one item always open) so the framed image is never
     blank. Selecting an item crossfades the frame to that item's photo. */
  function initIncludedAccordion(root) {
    var accs = (root || document).querySelectorAll("[data-oxy-incl]:not([data-oxy-incl-bound])");
    accs.forEach(function (acc) {
      acc.setAttribute("data-oxy-incl-bound", "1");
      var items = Array.prototype.slice.call(acc.querySelectorAll("[data-oxy-incl-item]"));
      var scope = acc.closest(".oxy-wrap") || acc.closest(".oxify-product-page") || document;
      var frame = scope.querySelector("[data-oxy-incl-frame]");
      var imgs = frame ? frame.querySelectorAll("[data-oxy-incl-img]") : [];
      var caps = frame ? frame.querySelectorAll("[data-oxy-incl-cap]") : [];
      // play the active layer's video (muted/looping), pause the rest
      function playActiveMedia() {
        for (var k = 0; k < imgs.length; k++) {
          var v = imgs[k].querySelector("video");
          if (!v) continue;
          if (imgs[k].classList.contains("is-active")) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { try { v.pause(); } catch (e) {} }
        }
      }
      items.forEach(function (item) {
        var btn = item.querySelector(".oxy-incl-accbtn");
        if (!btn) return;
        btn.addEventListener("click", function () {
          var i = item.getAttribute("data-oxy-incl-item");
          items.forEach(function (it) {
            var on = it === item;
            it.classList.toggle("is-open", on);
            var b = it.querySelector(".oxy-incl-accbtn");
            if (b) b.setAttribute("aria-expanded", on ? "true" : "false");
          });
          for (var k = 0; k < imgs.length; k++) imgs[k].classList.toggle("is-active", imgs[k].getAttribute("data-oxy-incl-img") === i);
          for (var m = 0; m < caps.length; m++) caps[m].classList.toggle("is-active", caps[m].getAttribute("data-oxy-incl-cap") === i);
          playActiveMedia();
          // mobile: media is stacked above the accordion, so reveal it on select
          if (frame && window.matchMedia("(max-width: 1080px)").matches) {
            frame.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
          }
        });
      });
      playActiveMedia();
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty(root) {
    var widgets = (root || document).querySelectorAll(".oxy-qty:not([data-oxy-qty-bound])");
    widgets.forEach(function (w) {
      w.setAttribute("data-oxy-qty-bound", "1");
      var input = w.querySelector("input");
      var minus = w.querySelector('[data-qty="minus"]');
      var plus = w.querySelector('[data-qty="plus"]');
      if (minus) minus.addEventListener("click", function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener("click", function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });
  }

  /* ---------- Variant picker / product form ---------- */
  function initVariantForms(root) {
    var forms = (root || document).querySelectorAll("[data-oxy-product-form]:not([data-oxy-vf-bound])");
    forms.forEach(function (formWrap) {
      formWrap.setAttribute("data-oxy-vf-bound", "1");
      var dataEl = formWrap.querySelector("[data-oxy-variants]");
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var moneyFormat = formWrap.getAttribute("data-money-format") || "${{amount}}";
      var idInput = formWrap.querySelector('[data-oxy-variant-id]');
      var priceEl = formWrap.querySelector("[data-oxy-price]");
      var compareEl = formWrap.querySelector("[data-oxy-compare]");
      var saveEl = formWrap.querySelector("[data-oxy-save]");
      var skuEl = formWrap.querySelector("[data-oxy-sku]");
      var availEl = formWrap.querySelector("[data-oxy-availability]");
      var atcText = formWrap.querySelector("[data-oxy-atc-text]");
      var atcBtn = formWrap.querySelector("[data-oxy-atc]");
      var optionInputs = Array.prototype.slice.call(formWrap.querySelectorAll("[data-oxy-option-index]"));
      var galleryEl = document.querySelector('[data-oxy-thumbgallery]');

      function formatMoney(cents) {
        var value = (cents / 100).toFixed(2);
        // Shopify default money format support: {{amount}} with 2 decimals.
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, value)
                          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString());
      }

      function currentOptions() {
        // Group radio/selects by option index.
        var byIndex = {};
        optionInputs.forEach(function (el) {
          var i = el.getAttribute("data-oxy-option-index");
          if (el.tagName === "SELECT") { byIndex[i] = el.value; }
          else if (el.getAttribute("aria-checked") === "true" || el.checked) { byIndex[i] = el.value; }
        });
        return [byIndex["1"], byIndex["2"], byIndex["3"]];
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return (opts[0] == null || v.option1 === opts[0]) &&
                 (opts[1] == null || v.option2 === opts[1]) &&
                 (opts[2] == null || v.option3 === opts[2]);
        });
      }

      function render(variant) {
        if (!variant) {
          if (atcBtn) { atcBtn.setAttribute("disabled", "disabled"); }
          if (atcText) atcText.textContent = "Unavailable";
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price_money || formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = variant.compare_money || formatMoney(variant.compare_at_price);
            compareEl.style.display = "";
            if (saveEl) {
              var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
              saveEl.textContent = "Save " + pct + "%";
              saveEl.style.display = "";
            }
          } else {
            compareEl.style.display = "none";
            if (saveEl) saveEl.style.display = "none";
          }
        }
        if (skuEl) skuEl.textContent = variant.sku ? "SKU: " + variant.sku : "";
        if (availEl) {
          availEl.textContent = variant.available ? (availEl.getAttribute("data-in-stock") || "In stock") : (availEl.getAttribute("data-sold-out") || "Sold out");
          availEl.classList.toggle("in-stock", variant.available);
          availEl.classList.toggle("sold-out", !variant.available);
        }
        if (atcBtn) {
          if (variant.available) { atcBtn.removeAttribute("disabled"); if (atcText) atcText.textContent = atcBtn.getAttribute("data-add-label") || "Add to cart"; }
          else { atcBtn.setAttribute("disabled", "disabled"); if (atcText) atcText.textContent = atcBtn.getAttribute("data-soldout-label") || "Sold out"; }
        }
        // swap gallery to the variant's featured media if present
        if (galleryEl && variant.featured_media_id) {
          galleryEl.dispatchEvent(new CustomEvent("oxy:select-media", { detail: { mediaId: variant.featured_media_id } }));
        }
        // keep URL variant param in sync (non-editor only)
        if (!window.Shopify || !window.Shopify.designMode) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set("variant", variant.id);
            window.history.replaceState({}, "", url.toString());
          } catch (e) {}
        }
      }

      optionInputs.forEach(function (el) {
        var evt = el.tagName === "SELECT" ? "change" : "click";
        el.addEventListener(evt, function () {
          if (el.tagName !== "SELECT") {
            // radio swatch behaviour: clear siblings of same option index
            var i = el.getAttribute("data-oxy-option-index");
            optionInputs.forEach(function (s) {
              if (s.getAttribute("data-oxy-option-index") === i && s.tagName !== "SELECT") {
                s.setAttribute("aria-checked", s === el ? "true" : "false");
              }
            });
          }
          render(findVariant(currentOptions()));
        });
      });

      // initial render
      var initial = findVariant(currentOptions());
      render(initial || variants[0]);
    });
  }

  /* ---------- Add-ons configurator ----------
     Cards are real Shopify products. Selection keeps a global registry;
     the hero's Add to cart submits chamber + selected add-ons together
     via /cart/add.js. With no add-ons selected the form submits natively. */
  function oxyFormatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || "${{amount}}")
      .replace(/\{\{\s*amount\s*\}\}/g, Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toLocaleString());
  }
  function initAddons(root) {
    var sections = (root || document).querySelectorAll("[data-oxy-addons]:not([data-oxy-addons-bound])");
    sections.forEach(function (sec) {
      sec.setAttribute("data-oxy-addons-bound", "1");
      var moneyFormat = sec.getAttribute("data-money-format") || "${{amount}}";
      var cards = Array.prototype.slice.call(sec.querySelectorAll("[data-oxy-addon]"));
      var countEl = sec.querySelector("[data-oxy-addons-count]");
      var totalEl = sec.querySelector("[data-oxy-addons-total]");

      function update() {
        var sel = cards.filter(function (c) { return c.getAttribute("aria-checked") === "true"; });
        var total = sel.reduce(function (s, c) { return s + (parseInt(c.getAttribute("data-price"), 10) || 0); }, 0);
        if (countEl) countEl.textContent = sel.length;
        if (totalEl) totalEl.textContent = oxyFormatMoney(total, moneyFormat);
        // global registry read by the product-form submit handler
        window.__oxyAddons = sel.map(function (c) { return { id: parseInt(c.getAttribute("data-variant-id"), 10), quantity: 1 }; });
        // Dynamic checkout bypasses our cart logic, so hide it while add-ons
        // are selected — buyers go through Add to cart and get everything.
        document.querySelectorAll(".oxy-dynamic-checkout").forEach(function (d) {
          d.style.display = sel.length ? "none" : "";
        });
      }

      cards.forEach(function (c) {
        if (c.getAttribute("data-available") !== "true") return;
        c.addEventListener("click", function () {
          var on = c.getAttribute("aria-checked") === "true";
          c.setAttribute("aria-checked", on ? "false" : "true");
          c.classList.toggle("is-on", !on);
          update();
        });
      });
      update();

      /* ---- leather selectors (one or more groups; each "choose one", free) ---- */
      // registry maps each property label -> chosen value; the cart submit
      // attaches all of them to the chamber line item.
      window.__oxyLeather = window.__oxyLeather || {};
      var groups = Array.prototype.slice.call(sec.querySelectorAll("[data-oxy-leather-group]"));
      groups.forEach(function (group) {
        var cards = Array.prototype.slice.call(group.querySelectorAll("[data-oxy-leather]"));
        if (!cards.length) return;
        var imgs = Array.prototype.slice.call(group.querySelectorAll("[data-oxy-leather-img]"));
        var pillDot = group.querySelector("[data-oxy-leather-dot]");
        var pillName = group.querySelector("[data-oxy-leather-pill]");
        var headName = group.querySelector("[data-oxy-leather-head]");
        var propLabel = group.getAttribute("data-property") || "Leather";
        var barSlot = sec.querySelector('[data-oxy-bar-for="' + propLabel + '"]');

        function select(i) {
          cards.forEach(function (c, idx) {
            var on = idx === i;
            c.classList.toggle("is-on", on);
            c.setAttribute("aria-checked", on ? "true" : "false");
          });
          imgs.forEach(function (im, idx) { im.classList.toggle("is-active", idx === i); });
          var card = cards[i];
          var name = card.getAttribute("data-name") || "";
          var color = card.getAttribute("data-color") || "";
          if (pillDot) pillDot.style.background = color;
          if (pillName) pillName.textContent = name;
          if (headName) headName.textContent = name;
          if (barSlot) barSlot.textContent = name;
          window.__oxyLeather[propLabel] = name;
          // hidden input per group so the NATIVE form submit records it too
          var form = document.querySelector('[data-oxy-product-form] form[action*="/cart/add"]');
          if (form) {
            var key = "oxy-leather-" + propLabel.replace(/[^a-z0-9]/gi, "");
            var inp = form.querySelector('input[data-leather-key="' + key + '"]');
            if (!inp) {
              inp = document.createElement("input");
              inp.type = "hidden";
              inp.setAttribute("data-leather-key", key);
              form.appendChild(inp);
            }
            inp.name = "properties[" + propLabel + "]";
            inp.value = name;
          }
        }
        cards.forEach(function (c, i) { c.addEventListener("click", function () { select(i); }); });
        select(0);
      });
    });
  }
  function initAddonSubmit(root) {
    var forms = (root || document).querySelectorAll('[data-oxy-product-form] form[action*="/cart/add"]:not([data-oxy-addonsubmit-bound])');
    forms.forEach(function (form) {
      form.setAttribute("data-oxy-addonsubmit-bound", "1");
      form.addEventListener("submit", function (e) {
        var addons = window.__oxyAddons || [];
        if (!addons.length) return; // no add-ons → normal Shopify submit
        e.preventDefault();
        var idEl = form.querySelector('input[name="id"]');
        var qtyEl = form.querySelector('input[name="quantity"]');
        var chamber = { id: parseInt(idEl.value, 10), quantity: qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1 };
        if (window.__oxyLeather && Object.keys(window.__oxyLeather).length) {
          chamber.properties = {};
          Object.keys(window.__oxyLeather).forEach(function (k) {
            if (window.__oxyLeather[k]) chamber.properties[k] = window.__oxyLeather[k];
          });
        }
        var items = [chamber];
        addons.forEach(function (a) { items.push(a); });
        var btn = form.querySelector("[data-oxy-atc]");
        if (btn) btn.setAttribute("disabled", "disabled");
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) throw new Error("cart add failed"); return r.json(); })
          .then(function () { window.location.href = "/cart"; })
          .catch(function () {
            // Fallback: at least add the chamber via the native form.
            if (btn) btn.removeAttribute("disabled");
            form.submit();
          });
      });
    });
  }

  /* ---------- Ambient oxygen particles (canvas) ---------- */
  function hexToRgb(hex) {
    var h = String(hex).trim().replace("#", "");
    if (h.length === 3) h = h.replace(/./g, function (c) { return c + c; });
    var n = parseInt(h.slice(0, 6), 16);
    if (isNaN(n)) return [74, 180, 255];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function initAmbient(root) {
    if (reduceMotion) return;
    var layers = (root || document).querySelectorAll(".oxify-product-page .oxy-ambient:not([data-oxy-ambient-bound])");
    layers.forEach(function (layer) {
      layer.setAttribute("data-oxy-ambient-bound", "1");
      var page = layer.closest(".oxify-product-page");
      var accent = "#4ab4ff";
      try { accent = (getComputedStyle(page).getPropertyValue("--oxy") || accent).trim() || accent; } catch (e) {}
      var density = parseFloat(layer.getAttribute("data-density"));
      if (isNaN(density)) density = 0.6;

      var canvas = document.createElement("canvas");
      layer.appendChild(canvas);
      var ctx = canvas.getContext("2d");
      var w = 0, h = 0, dpr = 1, raf = 0, t = 0, bubbles = [], running = false;
      var rgb = hexToRgb(accent);

      function spawn(anywhere) {
        return {
          x: Math.random() * w,
          y: anywhere ? Math.random() * h : h + Math.random() * 60,
          r: 0.6 + Math.random() * 2.6,
          sp: 0.12 + Math.random() * 0.55,
          drift: (Math.random() - 0.5) * 0.25,
          ph: Math.random() * Math.PI * 2,
          a: 0.12 + Math.random() * 0.55
        };
      }
      function resize() {
        dpr = Math.min(2, window.devicePixelRatio || 1);
        w = layer.clientWidth; h = layer.clientHeight;
        if (!w || !h) return;
        canvas.width = w * dpr; canvas.height = h * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        // area-based count, capped for performance
        var count = Math.min(120, Math.round((w * h) / 26000 * density));
        bubbles = []; for (var i = 0; i < count; i++) bubbles.push(spawn(true));
      }
      function draw() {
        t += 0.006;
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < bubbles.length; i++) {
          var p = bubbles[i];
          p.y -= p.sp;
          p.x += p.drift + Math.sin(t * 1.4 + p.ph) * 0.15;
          if (p.y < -10) { bubbles[i] = spawn(false); continue; }
          var tw = 0.6 + 0.4 * Math.sin(t * 2 + p.ph);
          var alpha = p.a * tw;
          var grd = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 3.4);
          grd.addColorStop(0, "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + alpha + ")");
          grd.addColorStop(0.35, "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + (alpha * 0.35) + ")");
          grd.addColorStop(1, "rgba(0,0,0,0)");
          ctx.fillStyle = grd;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 3.4, 0, Math.PI * 2); ctx.fill();
          ctx.fillStyle = "rgba(" + Math.min(255, rgb[0] + 90) + "," + Math.min(255, rgb[1] + 60) + ",255," + (alpha * 0.9) + ")";
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 0.5, 0, Math.PI * 2); ctx.fill();
        }
        raf = requestAnimationFrame(draw);
      }
      function start() { if (!running) { running = true; raf = requestAnimationFrame(draw); } }
      function stop() { running = false; cancelAnimationFrame(raf); }

      resize();
      window.addEventListener("resize", resize);
      // Only animate while the section is on screen.
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
        }, { threshold: 0 }).observe(layer);
      } else { start(); }
    });
  }

  /* ---------- Detail tabs ----------
     One [data-oxy-tabs] nav controls all [data-oxy-panel] sections on the
     page. A tab key may map to several panels (e.g. "features" = gallery +
     science). Panels are full sections; we show one key at a time. Content
     stays in the DOM (SEO-safe) and is simply display:toggled via a class. */
  function activateTab(nav, key, doScroll) {
    var btns = Array.prototype.slice.call(nav.querySelectorAll("[data-oxy-tab]"));
    btns.forEach(function (b) {
      var on = b.getAttribute("data-oxy-tab") === key;
      b.classList.toggle("is-active", on);
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
    var panels = document.querySelectorAll("[data-oxy-panel]");
    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.toggle("oxy-panel-active", panels[i].getAttribute("data-oxy-panel") === key);
    }
    // Only hide non-active panels once JS is proven working (graceful no-JS).
    document.documentElement.classList.add("oxy-tabs-ready");
    // Recompute layout-dependent widgets (sliders, filmstrip arrows) now visible.
    try { window.dispatchEvent(new Event("resize")); } catch (e) {}
    oxyCenterActiveTab(nav);
    oxySyncTabFades(nav);
    if (doScroll) {
      // If the bar is floating (fixed), the panel is already at/under it — only
      // scroll up when the bar has scrolled above the viewport in normal flow.
      var wrap = nav.closest(".oxy-tabs-wrap");
      if (wrap && !wrap.classList.contains("is-floating") && wrap.getBoundingClientRect().top < 0) {
        wrap.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      }
    }
  }
  function oxyTabScroller(nav) { return nav.querySelector(".oxy-tabs"); }
  function oxySyncTabFades(nav) {
    var sc = oxyTabScroller(nav), inner = nav.querySelector(".oxy-tabs-inner");
    if (!sc || !inner) return;
    var max = sc.scrollWidth - sc.clientWidth;
    inner.classList.toggle("can-left", sc.scrollLeft > 2);
    inner.classList.toggle("can-right", max > 2 && sc.scrollLeft < max - 2);
  }
  function oxyCenterActiveTab(nav) {
    var sc = oxyTabScroller(nav); if (!sc) return;
    var a = nav.querySelector(".oxy-tab.is-active"); if (!a) return;
    var target = a.offsetLeft - (sc.clientWidth - a.offsetWidth) / 2;
    target = Math.max(0, target);
    try { sc.scrollTo({ left: target, behavior: reduceMotion ? "auto" : "smooth" }); }
    catch (e) { sc.scrollLeft = target; }
  }
  function initTabs(root) {
    var navs = (root || document).querySelectorAll("[data-oxy-tabs]:not([data-oxy-tabs-bound])");
    navs.forEach(function (nav) {
      nav.setAttribute("data-oxy-tabs-bound", "1");
      var btns = Array.prototype.slice.call(nav.querySelectorAll("[data-oxy-tab]"));
      if (!btns.length) return;
      btns.forEach(function (b) {
        b.addEventListener("click", function () { activateTab(nav, b.getAttribute("data-oxy-tab"), true); });
      });
      nav.__oxyActivate = function (key) { activateTab(nav, key, false); };
      activateTab(nav, btns[0].getAttribute("data-oxy-tab"), false);
    });
  }
  /* Floating tab bar: pins to top across section boundaries via fixed-position
     (position:sticky can't span separate Shopify sections). A spacer keeps the
     layout from jumping. Un-pins once the collection/CTA reaches the bar. */
  function initFloatingTabs(root) {
    var navs = (root || document).querySelectorAll("[data-oxy-tabs]:not([data-oxy-float-bound])");
    navs.forEach(function (nav) {
      nav.setAttribute("data-oxy-float-bound", "1");
      var sc = oxyTabScroller(nav);
      if (sc) sc.addEventListener("scroll", function () { oxySyncTabFades(nav); }, { passive: true });
      oxySyncTabFades(nav);
      if (!nav.classList.contains("is-sticky")) return;
      var offset = parseInt(nav.style.getPropertyValue("--oxy-tabs-top"), 10) || 0;
      var spacer = document.createElement("div");
      spacer.className = "oxy-tabs-spacer";
      spacer.style.display = "none";
      nav.parentNode.insertBefore(spacer, nav.nextSibling);
      function flowTop() {
        var ref = nav.classList.contains("is-floating") ? spacer : nav;
        return ref.getBoundingClientRect().top + (window.pageYOffset || 0) - offset;
      }
      var baseY = flowTop();
      function endEl() { return document.querySelector("#chambers") || document.querySelector("#book") || document.querySelector(".oxy-cta"); }
      function onScroll() {
        var y = window.pageYOffset || 0, h = nav.offsetHeight, shouldFloat = y >= baseY - 0.5;
        var end = endEl();
        if (shouldFloat && end && end.getBoundingClientRect().top <= offset + h + 8) shouldFloat = false;
        if (shouldFloat && !nav.classList.contains("is-floating")) {
          spacer.style.height = h + "px"; spacer.style.display = "block"; nav.classList.add("is-floating");
        } else if (!shouldFloat && nav.classList.contains("is-floating")) {
          nav.classList.remove("is-floating"); spacer.style.display = "none";
        }
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", function () { baseY = flowTop(); onScroll(); oxySyncTabFades(nav); });
      onScroll();
    });
  }
  // Theme editor: when a hidden panel section is selected/loaded, reveal its tab.
  function oxyRevealPanelInEditor(target) {
    if (!target) return;
    var panel = null;
    if (target.getAttribute && target.getAttribute("data-oxy-panel")) panel = target;
    else if (target.querySelector) panel = target.querySelector("[data-oxy-panel]");
    if (!panel) return;
    var nav = document.querySelector("[data-oxy-tabs]");
    if (nav && nav.__oxyActivate) nav.__oxyActivate(panel.getAttribute("data-oxy-panel"));
  }

  /* ---------- Sticky CTA bar ----------
     Appears once the hero buy box scrolls out; hides again over the final
     CTA. Leads with the consultation CTA; "Add to cart" scrolls back to the
     real buy box (so add-on / leather choices are confirmed there). */
  function initStickyCta(root) {
    var bars = (root || document).querySelectorAll("[data-oxy-sticky-cta]:not([data-oxy-sticky-bound])");
    bars.forEach(function (bar) {
      bar.setAttribute("data-oxy-sticky-bound", "1");
      var buybox = document.querySelector(".oxy-buybox") || document.querySelector("[data-oxy-product-form]");
      var endZone = document.querySelector("#book") || document.querySelector(".oxy-cta");
      var atcBtn = bar.querySelector("[data-oxy-sticky-atc]");
      if (atcBtn) {
        atcBtn.addEventListener("click", function (e) {
          e.preventDefault();
          if (!buybox) return;
          buybox.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
          var realAtc = buybox.querySelector("[data-oxy-atc]");
          if (realAtc) { realAtc.classList.add("oxy-pulse"); setTimeout(function () { realAtc.classList.remove("oxy-pulse"); }, 1200); }
        });
      }
      // mirror the live (variant-aware) hero price into the bar
      var heroPrice = document.querySelector("[data-oxy-price]");
      var barPrice = bar.querySelector("[data-oxy-sticky-price]");
      if (heroPrice && barPrice) {
        var sync = function () { barPrice.textContent = heroPrice.textContent; };
        sync();
        if ("MutationObserver" in window) {
          new MutationObserver(sync).observe(heroPrice, { childList: true, characterData: true, subtree: true });
        }
      }
      function onScroll() {
        var show;
        if (buybox) { show = buybox.getBoundingClientRect().bottom <= 90; }
        else { show = (window.pageYOffset || 0) > 600; }
        if (show && endZone) {
          var vh = window.innerHeight || 800;
          if (endZone.getBoundingClientRect().top < vh * 0.85) show = false;
        }
        bar.classList.toggle("is-visible", show);
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      onScroll();
    });
  }

  /* ---------- init all ---------- */
  function initAll(root) {
    initReveal(root);
    initCounters(root);
    initSliders(root);
    initThumbGalleries(root);
    initFaq(root);
    initIncludedAccordion(root);
    initQty(root);
    initVariantForms(root);
    initAddons(root);
    initAddonSubmit(root);
    initAmbient(root);
    initTabs(root);
    initFloatingTabs(root);
    initStickyCta(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify theme editor: re-init when a section is loaded/changed,
  // and reveal the tab of any panel section being edited.
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); oxyRevealPanelInEditor(e.target); });
  document.addEventListener("shopify:section:select", function (e) { initAll(e.target); oxyRevealPanelInEditor(e.target); });
})();